import { Component, computed, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { HostControlDirective, InputAutocomplete, InputError } from '@ebeihilfe/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'portal-number-input',
  imports: [TranslateModule, ReactiveFormsModule, MatFormField, MatFormFieldModule, MatInput],
  templateUrl: './number-input.component.html',
  hostDirectives: [HostControlDirective],
})
export class NumberInputComponent {
  public accessorDirective = inject(HostControlDirective);
  public autocomplete = input<InputAutocomplete>('off');
  public errors = input<InputError[]>([]);
  public hasError = computed(() => {
    const control = this.accessorDirective.control;
    return control.invalid && (control.dirty || control.touched);
  });
  public hideRequiredMarker = input<boolean>(true);
  public hint = input<string>();
  public label = input.required<string>();
  public max = input<string>('');
  public min = input<string>('');
  public placeholder = input<string>('');
  public step = input<number>(1);
}
